
import { IGetIndicatorsParameters } from "./IGetIndicatorsParameters";


export class GetIndicatorsParameters implements IGetIndicatorsParameters
{
    componentId: number = 0;
    date: Date = new Date();
}
